import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
// eslint-disable-next-line no-unused-vars
import StoreImages from './StoreImages';
import XHSContentGeneratorCopy from './XHSContentGeneratorCopy';

const XHSCombinedCopy = () => {
  const location = useLocation();

  // Since this is the same tab, if user can access it, they can access both views
  // The route protection ensures they have xhs-content-generator permission

  // Determine initial view based on URL hash or default to generator
  const getInitialView = () => {
    const hash = location.hash;
    if (hash === '#generator') {
      return 'generator';
    } else if (hash === '#images') {
      return 'images';
    } else {
      // Default to generator view
      return 'generator';
    }
  };

  // eslint-disable-next-line no-unused-vars
  const [view, setView] = useState(() => getInitialView()); // 'images' or 'generator'

  // Update view when location changes
  useEffect(() => {
    const hash = location.hash;
    if (hash === '#generator') {
      setView('generator');
    } else if (hash === '#images') {
      setView('images');
    }
  }, [location.hash]);

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Box sx={{ width: '100%', height: '100%' }}>
        {view === 'images' && <StoreImages />}
        {view === 'generator' && <XHSContentGeneratorCopy />}
      </Box>
    </Box>
  );
};

export default XHSCombinedCopy;

